import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ProbabilidadPayload {
  descripcion: string;
  estado?: number;
}

/**
 * 🔹 Entidad
 */
export interface Probabilidad {
  id?: number;
  descripcion: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

/**
 * 🔹 Respuesta genérica
 */
export interface ProbabilidadResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ProbabilidadService {
  private readonly apiUrl = `${environment.apiUrl}/api/probabilidad`;

  constructor(private http: HttpClient) {}

  // Obtener todas las probabilidades
  getAll(): Observable<Probabilidad[]> {
    return this.http.get<Probabilidad[]>(this.apiUrl, {
      withCredentials: true,
    });
  }

  // Obtener probabilidad por ID
  getById(id: number): Observable<Probabilidad> {
    return this.http.get<Probabilidad>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Crear probabilidad
  create(
    payload: ProbabilidadPayload
  ): Observable<ProbabilidadResponse> {
    return this.http.post<ProbabilidadResponse>(
      this.apiUrl,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Actualizar probabilidad
  update(
    id: number,
    payload: Partial<ProbabilidadPayload>
  ): Observable<ProbabilidadResponse> {
    return this.http.put<ProbabilidadResponse>(
      `${this.apiUrl}/${id}`,
      payload,
      {
        withCredentials: true,
      }
    );
  }

  // Eliminar probabilidad
  remove(id: number): Observable<any> {
    return this.http.delete<any>(
      `${this.apiUrl}/${id}`,
      {
        withCredentials: true,
      }
    );
  }

  // Inactivar probabilidad
  inactivar(id: number): Observable<ProbabilidadResponse> {
    return this.http.put<ProbabilidadResponse>(
      `${this.apiUrl}/${id}/inactivar`,
      {},
      {
        withCredentials: true,
      }
    );
  }

  // Activar probabilidad
  activar(id: number): Observable<ProbabilidadResponse> {
    return this.http.put<ProbabilidadResponse>(
      `${this.apiUrl}/${id}/activar`,
      {},
      {
        withCredentials: true,
      }
    );
  }
}